<div class="verify-form">
  <div class="input-boxes">
    <span *ngFor="let item of [0, 1, 2, 3, 4, 5]" [class.active]="codeModel[item]" [class.next]="codeModel.length === item">
      {{ codeModel[item] }}
    </span>
  </div>
  <input
    class="verify-code-input"
    #verifyCodeInput
    [(ngModel)]="codeModel"
    (ngModelChange)="inputUpdate($event)"
    autocomplete="one-time-code"
    type="tel"
  />
</div>
